import { defaultTo } from "lodash";
import { useGlobal } from "@/migrated-widgets/table-map/contexts/GlobalState";
import { useAsync } from "@/migrated-widgets/table-map/hooks/useAsync";
import { PortalV2Service } from "@/migrated-widgets/table-map/services";

export const useLocationData = () => {
    const { params } = useGlobal();

    const { response: locations, loading: loadingLocations } = useAsync(async () => {
        const _params = {
            widgetId: "",
            productName: "",
            level: "LOCATION",
            segment: "campaign",
            startDate: params.startDate,
            endDate: params.endDate,
            dealerIds: params.dealerId,
            userGuid: params.userGuid,
            token: params.token,
            date: new Date().toString(),
        };

        const promises = await Promise.all([
            PortalV2Service.getLocationData({
                urlPath: `/mdl/getlocations?product=1`,
                ..._params,
            }),
            PortalV2Service.getLocationData({
                urlPath: `/mdl/getlocations?product=3`,
                ..._params,
            }),
            PortalV2Service.getLocationData({
                urlPath: `/mdl/getlocations?product=14`,
                ..._params,
            }),
            PortalV2Service.getLocationData({
                urlPath: `/mdl/getlocations?product=15`,
                ..._params,
            }),
        ]);

        const result = promises.reduce((acc: any, crr) => {
            return {
                radius: {
                    type: "FeatureCollection",
                    features: [...defaultTo(acc?.radius?.features, []), ...defaultTo(crr?.radius?.features, [])],
                },
                location: {
                    type: "FeatureCollection",
                    features: [...defaultTo(acc?.location?.features, []), ...defaultTo(crr?.location?.features, [])],
                },
                states: {
                    type: "FeatureCollection",
                    features: [...defaultTo(acc?.states?.features, []), ...defaultTo(crr?.states?.features, [])],
                },
                cities: {
                    type: "FeatureCollection",
                    features: [...defaultTo(acc?.cities?.features, []), ...defaultTo(crr?.cities?.features, [])],
                },
                zipRegion: {
                    type: "FeatureCollection",
                    features: [...defaultTo(acc?.zipRegion?.features, []), ...defaultTo(crr?.zipRegion?.features, [])],
                },
                circleMarkers: [...defaultTo(acc?.circleMarkers, []), ...defaultTo(crr?.circleMarkers, [])],
                geometryFeatures: [...defaultTo(acc?.geometryFeatures, []), ...defaultTo(crr?.geometryFeatures, [])],
            };
        }, {});

        return result;
    }, [params]);

    return {
        locations,
        loadingLocations,
    };
};
